/*
 * IMPORTS
 */
import { gql } from '@apollo/client'




/*
 * GRAPHS
 */

const Index = gql`
query CustomerAccountStatsReportQuery($customerAccountId: ID!, $country: String, $startDate: DateTime, $endDate: DateTime) {
  CustomerAccountStatsReport(customerAccountId: $customerAccountId, country: $country, startDate: $startDate, endDate: $endDate) {
    _reportData,
    id,
    message,
    status
  }
}
`


/*
 * EXPORTS
 */
export default Index
